<template>
  <div id="app">
    <AppHeader v-if="$route.path !== '/'" :shopName="activeShopName" :telNo="activeShopTelNo" :activeDrInfo="activeDrInfo"
    @toggle-new-grid-view="handleToggleNewGridView" :showNewGrid="showNewGrid" :indexGoal="indexGoal"
    @toggle-new-grid-se-view="handleToggleNewSeGridView" :showNewSeListGrid="showNewSeListGrid"
    />

    <main class="content">
      <!-- top-info-change: SeListPage.vue , useNewGrid: BmListPage.vue -->
      <router-view @top-info-change="updateActiveTopInfo" 
      :useNewGrid="showNewGrid" :key="$route.fullPath" 
      :useNewSeListGrid="showNewSeListGrid"
      @reset-grid-view="resetGridView"/>
    </main>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      activeShopName: "",
      activeShopTelNo: "",
      activeDrInfo: null,
      showNewGrid: false,
      indexGoal: "",
      showNewSeListGrid: false,
    };
  },
  methods: {
    updateActiveTopInfo(topDetails) { // shopDetails는 { shopName: '...', telNo: '...' } 객체
      this.activeShopName = topDetails.shopName;
      this.activeShopTelNo = topDetails.telNo;

      // drTotalRankData가 배열로 오는지 확인하고, 배열이면 첫 번째 객체를 사용합니다.
      if (Array.isArray(topDetails.drTotalRankData) && topDetails.drTotalRankData.length > 0) {
        this.activeDrInfo = topDetails.drTotalRankData[0];
      } else {
        // 배열이 아니거나 비어있으면 받은 값 그대로 할당합니다.
        this.activeDrInfo = topDetails.drTotalRankData;
      }

      // indexGoal 데이터 전달
      if (topDetails.indexGoal !== undefined) {
        this.indexGoal = topDetails.indexGoal;
      }
    },
    handleToggleNewGridView() {
        this.showNewGrid = !this.showNewGrid;
      // console.log("📌 그리드 뷰 토글됨:", this.showNewGrid ? '경영지도' : '달성률');
        
    },
    handleToggleNewSeGridView() {
      this.showNewSeListGrid = !this.showNewSeListGrid;
    },
    resetGridView() {
      this.showNewSeListGrid = false;
    },
  },
  watch: {
    // 다른 페이지로 이동하면 useNewGrid 상태를 초기화합니다.
    '$route.path'(newPath) {
      if (newPath !== '/BmListPage' && this.showNewGrid) {
        this.showNewGrid = false;
      }
      if (newPath !== '/SeListPage' && this.showNewSeListGrid) {
        this.showNewSeListGrid = false;
      }
    },
      
    
  },
};
</script>

<style>

/* 브라우저 기본 여백 제거 */
html,
body {
  /*   margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; /* 스크롤 방지 */
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  background-color: #f0f0f0; /* 배경색 */
  overflow: hidden; /* 스크롤 방지 */
}

#app {
  width: 100%;
  height: 100%;
  background-color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* 그림자 효과 */
  border: 1px solid #ccc; /* 테두리 */
  display: flex;
  flex-direction: column;
}
/* 메인 콘텐츠 영역 */
.content {
  flex: 1;
  overflow: auto; /* 내부 콘텐츠 스크롤 허용 */
}
</style>
